import styles from './ButtonRoundWithHarpoon.module.scss'
import Harpoon from 'public/images/harpoon-right.svg'
import { MouseEventHandler } from 'react'

interface ButtonRoundWithHarpoonProps {
  message: string
  onClick: MouseEventHandler<HTMLButtonElement>
  className?: string
}

export default function ButtonRoundWithHarpoon(props: ButtonRoundWithHarpoonProps) {
  const { message, onClick, className } = props
  return (
    <button
      className={ `${className} ${styles.ButtonRoundWithHarpoon}` }
      onClick={ onClick }
    >
      <p
        className={ styles.message }
        dangerouslySetInnerHTML={ { __html: message } }
      />
      <Harpoon className={ styles.harpoon }/>
    </button>
  )
}
